import React from "react"
import {useParams} from "react-router-dom"
import similarGames from "../assets/mock/db/games/similar.json"
import CommonSlider from "../commonComponents/CommonSlider"
import BannerGame from "../commonComponents/BannerGame"
import allGames from "../assets/mock/db/games/all.json"

function Game(props) {
    console.log('inside game container', props)
    const {id} = useParams()
    console.log(">>>params id:::", id)
    const settings = {
        dots: true,
        infinite: true,
        speed: 500
    };
    const game = allGames.find(game => game.id === id)
    return (
        <React.Fragment>
            <BannerGame game={game}/>
            <div className="container m-w">
                <CommonSlider
                    settings={{
                    ...settings,
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '10%',
                    swipeToSlide: true
                }}
                    title="العاب مماثلة"
                    data={similarGames}/>
            </div>
        </React.Fragment>
    )
}

export default Game